import { render, staticRenderFns } from "./myCommunity.vue?vue&type=template&id=2d78138a&scoped=true&"
import script from "./myCommunity.vue?vue&type=script&lang=js&"
export * from "./myCommunity.vue?vue&type=script&lang=js&"
import style0 from "./myCommunity.vue?vue&type=style&index=0&id=2d78138a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d78138a",
  null
  
)

export default component.exports